import React from 'react';
import PropType from 'prop-types';
import Rating from 'react-rating';
import numeral from 'numeral';

const AudienceRating = props => (
  <div className="tvt-audience-ratings">
    {!props.loading &&
    (<>
      <div className="tvt-audience-ratings__rating">
        {numeral(props.rating).format('0.0')}
      </div>
      <div className="tvt-audience-ratings__divider"/>
      <Rating
        initialRating={props.rating}
        emptySymbol="fa fa-star fa-2x tvt-audience-ratings__empty-rating"
        fullSymbol="fa fa-star fa-2x tvt-audience-ratings__full-rating"
        fractions={5}
        readonly
      />
      <div className="tvt-audience-ratings__votes">
        {numeral(props.votes).format('0,0')} Reviews
      </div>
    </>)
    }
    {props.loading &&
    (<>
      <div className="tvt-audience-ratings__loading" />
      <div className="tvt-audience-ratings__loading" />
    </>)
    }
  </div>
);

AudienceRating.propTypes = {
  rating: PropType.number,
  votes: PropType.number,
  loading: PropType.bool,
};

AudienceRating.defaultProps = {
  rating: 0,
  votes: 0,
  loading: false
};

export default AudienceRating;
